// @vendor
const React = require("react");
const PropTypes = require("prop-types");
// @components
const OKInformativeList = require("components/rebrand/OKInformativeList/OKInformativeList");
const OKInformativeListItem = require("components/rebrand/OKInformativeListItem/OKInformativeListItem");
const { OKMessage } = require("commonsComponents/OKMessage");
const WizardSuccess = require("components/commons/wizardSuccess/wizardSuccess");
// @core
const { FormattedText, formatText } = require("core/i18n").i18n;
//@utilities
const {
    decimalsLength,
    formatWithoutRound,
    getFormattedString,
} = require("utilities/currencyHelper");
const { PERCENTAGE_SYMBOL } = require("constants/index");
const { mapContractingData, mapTotalCostInfo } = require("../contractAresLoanHelper");
const { recordLinkV2, recordPathV2 } = require('utilities/tagging');
const { catalogue, analyticsId } = require( "../analytics/contractAresLoanAnalytics" );

class ContractAresLoanSuccess extends React.Component {
    
    componentDidMount() {
        recordPathV2(catalogue[analyticsId.SUCCESS_VIEW]());
    }

    formatInterest(interest) {
        return formatWithoutRound(
            interest,
            decimalsLength(interest),
            "es"
        ).concat(" ", PERCENTAGE_SYMBOL);
    }

    buildList() {
        const { contractingData, paymentDayType } = this.props;
        const immData = mapContractingData(contractingData, paymentDayType);
        const tin = immData.get("tin");
        const totalAmount = getFormattedString({
            amount: immData.get('totalAmount'),
            currency: immData.get('currency'),
            decimalsLength: decimalsLength(immData.get('totalAmount')),
        });

        const fields = [
            {
                title: formatText(`contractLoanSuccess-loanImportContracts`),
                bodyText: getFormattedString({
                    amount: immData.get("selectedAmount"),
                    decimalsLength: 0,
                    currency: immData.get("currency"),
                }),
            },
            {
                title: formatText("contractLoanSuccess-tin"),
                bodyText: this.formatInterest(tin),
            },
            {
                title: formatText("contractEasyLoanSuccess-term"),
                bodyText: formatText("contractEasyLoan-termMonths", [
                    immData.get("selectedTerm"),
                ]),
            },
            {
                title: formatText("contractEasyLoan-monthlyInstallment"),
                bodyText: getFormattedString(immData.get("installment")),
            },
            {
                title: formatText("contractEasyLoan-TAE"),
                bodyText: this.formatInterest(immData.get("tae")),
            },
            {
                title: 'contractLoanSuccess-totalAmountLabel',
                bodyText: totalAmount,
                icon: 'icon-informacion',
                tooltipPlacement: 'right',
                tooltipModifier: 'dark-bg',
                tooltipAlternativeIcon: true,
                tooltipOffset: [10, 0],
                className: 'title-bold item-compact item-tae',
                information: formatText('contractLoanSuccess-totalAmountTooltip', [mapTotalCostInfo(contractingData, paymentDayType)]),

            }
        ];

        return fields.map((field, index) => {
            return (
                <OKInformativeListItem
                    key={field.title + index}
                    title={field.title}
                    bodyText={field.bodyText}
                    icon={field.icon}
                    iconCustomClass={field.iconCustomClass}
                    information={field.information}
                    tooltipClassName={field.tooltipClassName}
                    tooltipOffset={field.tooltipOffset}
                    tooltipPlacement={field.tooltipPlacement}
                    tooltipModifier={field.tooltipModifier}
                />
            );
        });
    }

    buildSubTitle() {
        return (
            <div className="contract-ares-loan-success__subtitle--top-space">
                <FormattedText value="aresLoan-mbBanking.products.loansAndMortgages.productContracting.success_personalLoanContracting.mbConfirmationOperativeHeader" />
            </div>
        );
    }

    buildInformativeText(email) {
        return (
            <OKMessage type="informative">
                <div>
                    <div>
                        <FormattedText value="contractLoanSuccess-informativeText" />
                        <b>{email}</b>
                        <FormattedText value="contractLoanSuccess-informativeText2" />
                    </div>
                    <div>
                        <FormattedText value="contractLoanSuccess-informativeText3" />
                    </div>
                </div>
            </OKMessage>
        );
    }

    handleMainButtonAnalytics() {
        recordLinkV2(catalogue[analyticsId.NAVIGATION_RETURN_TO_GP]());
    }

    buildContent() {
        const { email } = this.props;

        let subMessage;
        const listItems = this.buildList();
        const goToGlobalPosition = {
            label: formatText("contractEasyLoanError-goBackLinkText"),
            url: "/myprofile/global",
        };

        const subTitleText = this.buildSubTitle();
        const informativeText = this.buildInformativeText(email);

        return (
            <WizardSuccess
                successMessage={subTitleText}
                successSubMessage={subMessage}
                mainButton={goToGlobalPosition}
                onMainButtonClick={this.handleMainButtonAnalytics}
                secondaryButtonStyle="link-complementary"
            >
                <div>
                    <div className="contract-ares-loan-success__col-separator" />
                    <OKInformativeList columns={2}>
                        {listItems}
                    </OKInformativeList>
                    {informativeText}
                </div>
            </WizardSuccess>
        );
    }

    render() {
        const content = this.buildContent();

        return (
            <article className="row no-gutter">
                <div className="col-xs-offset-1 col-xs-9">{content}</div>
            </article>
        );
    }
}

ContractAresLoanSuccess.propTypes = {
    contractingData: PropTypes.object.isRequired,
    paymentDayType: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
};

module.exports = ContractAresLoanSuccess;
